// Indicador de estado de sincronización en vivo (diagnóstico).
// - Verde "En vivo": el listener está recibiendo datos del servidor (fromCache=false).
// - Ámbar "Reconectando…": está sirviendo de la caché local (sin push en vivo).
// - Rojo "Sin internet": el navegador reporta offline.
// Botón 🔄 para forzar una resincronización (disable/enableNetwork).
// Se engancha a config/app (doc que ya existe y leen todos) con includeMetadataChanges
// para leer snapshot.metadata.fromCache / hasPendingWrites.
import React, { useEffect, useState } from "react";
import { doc, onSnapshot, disableNetwork, enableNetwork } from "firebase/firestore";
import { db } from "../firebase";

export default function SyncStatus() {
  const [fromCache, setFromCache] = useState(false);
  const [pending, setPending] = useState(false);
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let unsub = () => {};
    try {
      unsub = onSnapshot(
        doc(db, "config", "app"),
        { includeMetadataChanges: true },
        (snap) => {
          setFromCache(!!snap.metadata.fromCache);
          setPending(!!snap.metadata.hasPendingWrites);
        },
        () => {}
      );
    } catch (_) {}
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      try { unsub(); } catch (_) {}
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  async function resync() {
    if (busy) return;
    setBusy(true);
    try { await disableNetwork(db); await enableNetwork(db); } catch (_) {}
    finally { setBusy(false); }
  }

  const estado = !online
    ? { t: "Sin internet", c: "#b91c1c", bg: "#fee2e2" }
    : pending
      ? { t: "Sincronizando…", c: "#b45309", bg: "#fef3c7" }
      : fromCache
        ? { t: "Reconectando…", c: "#b45309", bg: "#fef3c7" }
        : { t: "En vivo", c: "#15803d", bg: "#dcfce7" };

  return (
    <div style={{
      position: "fixed", bottom: 10, left: 10, zIndex: 9000,
      display: "flex", alignItems: "center", gap: 6,
      background: estado.bg, color: estado.c, border: `1px solid ${estado.c}44`,
      borderRadius: 999, padding: "4px 10px 4px 11px", fontSize: 12, fontWeight: 700,
      boxShadow: "0 1px 4px rgba(15,23,42,0.14)", userSelect: "none",
    }}>
      <span style={{
        width: 8, height: 8, borderRadius: "50%", background: estado.c,
        display: "inline-block", flexShrink: 0,
        animation: (estado.t === "En vivo") ? "none" : "sblink 1s ease-in-out infinite",
      }} />
      {estado.t}
      <button onClick={resync} disabled={busy} title="Forzar sincronización"
        style={{ border: "none", background: "transparent", cursor: busy ? "default" : "pointer", color: estado.c, fontSize: 13, padding: "0 1px", lineHeight: 1 }}>
        {busy ? "⏳" : "🔄"}
      </button>
      <style>{`@keyframes sblink { 0%,100%{opacity:1} 50%{opacity:.35} }`}</style>
    </div>
  );
}
